var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"w-100"},[_c('b-col',{attrs:{"md":"12"}},[_c('div',{staticClass:"clearfix centerDiv"},[_c('h3',{staticClass:"pt-3"},[_vm._v(_vm._s(_vm.$t(this.$getConst.pages.error.error_message_+this.$store.getters["auth/scopeDefault"].name)))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }